import axiosClient from './axiosClient';

const ridePricingApi = {
  getPolicies: (params) => axiosClient.get('/rides/pricing-policies', { params }),
  getPolicy: (pricingPolicyId) => axiosClient.get(`/rides/pricing-policies/${pricingPolicyId}`),
  createDraft: (payload) => axiosClient.post('/rides/pricing-policies', payload),
  updateDraft: (pricingPolicyId, payload) => axiosClient.put(`/rides/pricing-policies/${pricingPolicyId}`, payload),
  activate: (pricingPolicyId) => axiosClient.post(`/rides/pricing-policies/${pricingPolicyId}/activate`),
};

export default ridePricingApi;
